module.exports = __webpack_public_path__ + "img/logo-redirect.e47d609e.svg";